module.exports = __webpack_public_path__ + "img/google-forms.bac29ba2.svg";